import { Box, useDisclosure } from '@chakra-ui/react';
import Navbar from 'components/navbar/NavbarAdmin.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes.js';

export default function Dashboard(props) {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { onOpen } = useDisclosure();

  const adminRoutes = routes.filter((route) => route.layout === '/admin');

  return (
    <Box>
        <Navbar />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          mt="80px"
          w={{ base: '100%', xl: '100%' }}
          maxWidth={{ base: '100%', xl: '100%' }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
        >
          <Box mx="auto" minH="100vh">
            <Routes>
              {adminRoutes.map((route, i) => (
                <Route key={i} path={route.path} element={route.component} />
              ))}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Box>
        </Box>
    </Box>
  );
}
